import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule } from '@angular/forms';

import { AppComponent } from './app.component';
import { VertrekComponent } from './vertrek/vertrek.component';
import { Halte1Component } from './halte1/halte1.component';
import { Halte2Component } from './halte2/halte2.component';
import { Halte3Component } from './halte3/halte3.component';
import { Halte4Component } from './halte4/halte4.component';
import { Halte5Component } from './halte5/halte5.component';
import { Halte6Component } from './halte6/halte6.component';
import { Halte7Component } from './halte7/halte7.component';
import { Halte8Component } from './halte8/halte8.component';
import { HeaderComponent } from './header/header.component';
import { InfoComponent } from './info/info.component';
import { FooterComponent } from './footer/footer.component';
import { EindeComponent } from './einde/einde.component';


const routes: Routes = [
  { path: 'info', component: InfoComponent},
  { path: 'vertrek', component: VertrekComponent },
  { path: 'einde', component: EindeComponent },
  { path: 'halte1', component: Halte1Component},
  { path: 'halte2', component: Halte2Component},
  { path: 'halte3', component: Halte3Component},
  { path: 'halte4', component: Halte4Component},
  { path: 'halte5', component: Halte5Component},
  { path: 'halte6', component: Halte6Component},
  { path: 'halte7', component: Halte7Component},
  { path: 'halte8', component: Halte8Component},
  { path: '**', redirectTo: '/info', pathMatch: 'full'},
  { path: '', redirectTo: '/info', pathMatch: 'full'}
];



@NgModule({
  declarations: [
    AppComponent,
    VertrekComponent,
    Halte1Component,
    Halte2Component,
    Halte3Component,
    Halte4Component,
    Halte5Component,
    Halte6Component,
    Halte7Component,
    Halte8Component,
    HeaderComponent,
    InfoComponent,
    FooterComponent,
    EindeComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    RouterModule.forRoot(routes)
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
